import {
    // Fragment,
    useEffect,
    useState,
} from "react";

// import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
// import { Separator } from "@/components/ui/separator";
// import { Switch } from "@/components/ui/switch";
// import { cn } from "@/lib/utils";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group.tsx";
import { useGetWebSettings } from "@/api/chat-settings/get-web-settings.ts";
import CustomWebSettingsForm from "@/components/chat-settings/integration/custom-web-settings-form.tsx";
import ShopifyWebSettingsForm from "@/components/chat-settings/integration/shopify-web-settings-form.tsx";
import WooCommerceWebSettingsForm from "@/components/chat-settings/integration/woocommerce_web_settings_form.tsx";
import useGlobalPermission from "@/store/user-permissions";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

const Integration = () => {
    // const [integrationStatus, setIntegrationStatus] = React.useState(false);
    const [websiteType, setWebsiteType] = useState("shopify");
    const [paginationMode, setPaginationMode] = useState("scroll"); // Default to scroll mode
    const [locator, setLocator] = useState("");

    const { data: webSettings } = useGetWebSettings();

    useEffect(() => {
        setWebsiteType(webSettings?.data?.website_type);
        if (webSettings?.data?.mode) {
            setPaginationMode(webSettings?.data?.mode);
        }
        if (webSettings?.data?.locator) {
            setLocator(webSettings?.data?.locator);
        }
    }, [webSettings]);

    const { permissionList } = useGlobalPermission();
    const webPermission = permissionList.find((item) => item.module.name === "Web_Settings");

    return (
        <div className="relative">
            {!webPermission?.can_create && (
                <Alert variant="destructive" className="absolute z-10 top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 max-w-2xl">
                    <AlertCircle className="h-4 w-4" />
                    <AlertTitle>Error</AlertTitle>
                    <AlertDescription>You do not have permission to view this list!</AlertDescription>
                </Alert>
            )}
            <div className={cn(!webPermission?.can_create && "blur-md")}>
                {/* <Card className="mt-4 p-4 text-gray-700 shadow-none">
                <div className="flex items-center justify-between">
                    <div className="flex gap-10">
                        <h3 className="text-lg font-bold">Custom Order Tracking API integration</h3>
                        <p>
                            Status:{" "}
                            <span className={cn(integrationStatus ? "text-green-600" : "text-red-600")}>
                                {integrationStatus ? "Active" : "Inactive"}
                            </span>
                        </p>
                    </div>
                    <div className="flex items-center gap-2">
                        <Label htmlFor="toggle_order_tracking">{integrationStatus ? "Deactivate" : "Activate"}</Label>
                        <Switch id="toggle_order_tracking" checked={integrationStatus} onCheckedChange={(v) => setIntegrationStatus(v)} />
                    </div>
                </div>
                <div>
                    <p>Connect Chatbot to your internal system via a custom integration</p>
                </div>
                {integrationStatus && (
                    <Fragment>
                        <Separator className="my-4" />
                        <h3 className="text-lg font-bold">Follow these steps to connect a custom tracking endpoint to Chatbot:</h3>
                        <ul className="list-inside list-disc">
                            <li>Forward the Custom Order Tracking API documentation to your developer to integrate with Chatbot</li>
                            <li>Implement the endpoint in your system</li>
                            <li>Add the endpoint URL and API key to Chatbot</li>
                            <li>Provide example order format and enable order tracking from Chat Settings / Configuration</li>
                            <li>Go to Test Chat and ask where your order is</li>
                        </ul>
                        <h3 className="mt-4 font-bold">API Key</h3>
                        <p className="my-2">An API key to authenticate with your internal system</p>
                        <Input placeholder="Enter API Key" className="h-12" />
                        <h3 className="mt-4 font-bold">Order Tracking API Endpoint</h3>
                        <p className="my-2">API endpoint in your system that Chatbot can call to check order status</p>
                        <Input placeholder="Enter API Key" className="h-12" />
                    </Fragment>
                )}
            </Card> */}
                {/* {integrationStatus && (
                    <Card className="mt-4 p-4 shadow-none">
                        <div className="flex items-center justify-end">
                            <Button>Save</Button>
                        </div>
                    </Card>
                )} */}
                <Card className={"mt-4 p-4 text-gray-700 shadow-none"}>
                    <h3 className="font-semibold text-lg">Web Integration</h3>
                    <div>
                        <p className="my-4 text-base font-semibold">Select Your E-Commerce Platform</p>
                        <RadioGroup
                            disabled={!webPermission?.can_create || !webPermission?.can_update}
                            defaultValue="comfortable"
                            onValueChange={(value) => setWebsiteType(value)}
                            value={websiteType}
                            className="flex items-center justify-between"
                        >
                            <div className="flex items-center space-x-2">
                                <RadioGroupItem value="shopify" id="shopify" />
                                <Label htmlFor="shopify" className="flex items-center gap-2">
                                    <img src={"/assets/images/logo/shopify_logo.png"} height={50} width={50} alt="Shopify Logo" className="size-7" />
                                    <p className="text-base font-semibold">Shopify</p>
                                </Label>
                            </div>
                            <div className="flex items-center space-x-2">
                                <RadioGroupItem value="woocommerce" id="woocommerce" />
                                <Label htmlFor="woocommerce" className="flex items-center gap-2">
                                    <img
                                        src={"/assets/images/logo/woocommerce_logo.png"}
                                        height={50}
                                        width={50}
                                        alt="Shopify Logo"
                                        className="size-7"
                                    />
                                    <p className="text-base font-semibold">Woocommerce</p>
                                </Label>
                            </div>
                            {/* <div className="flex items-center space-x-2">
                                <RadioGroupItem value="magento" id="magento" />
                                <Label htmlFor="magento" className="flex items-center gap-2">
                                    <img src={"/assets/images/logo/magento_logo.png"} height={50} width={50} alt="Shopify Logo" className="size-7" />
                                    <p className="text-base font-semibold">Magento</p>
                                </Label>
                            </div> */}
                            <div className="flex items-center space-x-2">
                                <RadioGroupItem value="custom" id="custom" />
                                <Label htmlFor="custom" className="flex items-center gap-2">
                                    <img src={"/assets/images/logo/custom_logo.png"} height={50} width={50} alt="Shopify Logo" className="size-7" />
                                    <p className="text-base font-semibold">Custom CMS</p>
                                </Label>
                            </div>
                            <div className="flex items-center space-x-2">
                                <RadioGroupItem value="others" id="others" />
                                <Label htmlFor="others" className="flex items-center gap-2">
                                    <img src={"/assets/images/logo/others_logo.png"} height={50} width={50} alt="Shopify Logo" className="size-7" />
                                    <p className="text-base font-semibold">Others</p>
                                </Label>
                            </div>
                        </RadioGroup>
                        <div className="mb-6 mt-6">
                            <p className="text-base font-semibold mb-4">Pagination Settings</p>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <Label htmlFor="mode" className="text-sm font-medium mb-2 block">Mode</Label>
                                    <RadioGroup
                                        value={paginationMode}
                                        onValueChange={setPaginationMode}
                                        className="flex space-x-4"
                                    >
                                        <div className="flex items-center space-x-2">
                                            <RadioGroupItem value="scroll" id="scroll" />
                                            <Label htmlFor="scroll">Scroll</Label>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <RadioGroupItem value="next_button" id="next_button" />
                                            <Label htmlFor="next_button">Next Button</Label>
                                        </div>
                                    </RadioGroup>
                                </div>
                                
                                {paginationMode === 'next_button' && (
                                    <div>
                                        <Label htmlFor="locator" className="text-sm font-medium mb-2 block">Locator</Label>
                                        <Input
                                            id="locator"
                                            placeholder="Enter button selector (e.g., .next-button, #load-more)"
                                            value={locator}
                                            onChange={(e) => setLocator(e.target.value)}
                                            className="py-5"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        
                        <p className="mb-4 mt-6 text-base font-semibold">Enter E-Commerce URL</p>
                        {/*<Input placeholder="https://example.com" className="w-full py-6 text-gray-500" type="url" readOnly />*/}
                        {websiteType === "shopify" && (
                            <ShopifyWebSettingsForm
                                id={webSettings?.data?.id}
                                shopify_access_token={webSettings?.data?.shopify_access_token}
                                shopify_api_key={webSettings?.data?.shopify_api_key}
                                shopify_api_secret={webSettings?.data?.shopify_api_secret}
                                website_url={webSettings?.data?.website_url}
                                mode={paginationMode}
                                locator={locator}
                            />
                        )}
                        {(websiteType === "custom" || websiteType === "others") && (
                            <CustomWebSettingsForm 
                                id={webSettings?.data?.id} 
                                website_url={webSettings?.data?.website_url} 
                                mode={paginationMode}
                                locator={locator}
                            />
                        )}
                        {websiteType === "woocommerce" && (
                            <WooCommerceWebSettingsForm
                                id={webSettings?.data?.id}
                                website_url={webSettings?.data?.website_url}
                                wordpress_consumer_secret={webSettings?.data?.wordpress_consumer_secret}
                                wordpress_consumer_key={webSettings?.data?.wordpress_consumer_key}
                                mode={paginationMode}
                                locator={locator}
                            />
                        )}
                        {/*<div className="mt-6 flex justify-end gap-4">*/}
                        {/*    <Button variant={"secondary"}>*/}
                        {/*        Skip For Now*/}
                        {/*    </Button>*/}
                        {/*    <Button>Save & Proceed</Button>*/}
                        {/*</div>*/}
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default Integration;
